/* eslint-disable sonarjs/cognitive-complexity -- TODO: Refactor this function */
import { v4 as uuidv4 } from "uuid";
import {
  getHeightOptions,
  getWidthOptions,
} from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontWeightOptions,
} from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as CardDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/CallToAction/CardCallToAction/CardCallToActionDefaultData";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createButtonBlock,
  createH5Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getMarginOptions } from "../../../utils/boxModelStyleHelpers";
import { getBorderRadiusOptions } from "../../../utils/imgStyleHelpers";
import { createHrBlock } from "./hrBlockHelper";

export const createCardBlock = ({
  highlight = "",
  image = { signedId: "", placeholder: "" },
  h5Text = "",
  pText = "",
  ulList = [],
  hasDivider = false,
  description = "",
  button = {
    text: "",
    href: "",
  },
  value = [],
  styles = {},
}: {
  highlight?: string;
  image?: {
    signedId: string;
    placeholder?: string;
  };
  h5Text?: string;
  pText?: string;
  ulList?: string[] | { text: string; placeholder?: string }[];
  hasDivider?: boolean;
  description?: string;
  button?: {
    text: string;
    href: string;
  };
  value?: BaseBlock[];
  styles?: Record<string, StyleValue>;
}): BaseBlock => ({
  ...CardDefaultData,
  id: uuidv4(),
  props: {
    ...CardDefaultData.props,
    highlight: {
      ...CardDefaultData.props.highlight,
      prop: "other",
      type: "string",
      value: highlight,
    },
    content: {
      ...CardDefaultData.props.content,
      type: "children",
      prop: "children",
      value:
        value && value.length > 0
          ? value
          : [
              ...(image && "signedId" in image
                ? [
                    createImageBlock({
                      signedId: image.signedId,
                      placeholder: image.placeholder,
                      styles: {
                        width: getWidthOptions({
                          defaultValue: "3.375rem",
                        }),
                        height: getHeightOptions({
                          defaultValue: "3.375rem",
                        }),
                        borderRadius: getBorderRadiusOptions({
                          defaultValue: {
                            border_left_top_radius: 100,
                            border_left_bottom_radius: 100,
                            border_right_top_radius: 100,
                            border_right_bottom_radius: 100,
                          },
                        }),
                        backgroundColor: getBackgroundColorOptions({
                          defaultValue: "var(--theme-website-color-5)",
                        }),
                      },
                    }),
                  ]
                : []),
              ...(h5Text
                ? [
                    createH5Block({
                      text: h5Text,
                    }),
                  ]
                : []),
              ...(pText
                ? [
                    createPBlock({
                      text: pText,
                      paragraphStyle: "p3",
                    }),
                  ]
                : []),
              ...(ulList && ulList.length > 0
                ? [
                    createUlBlock({
                      items: ulList,
                    }),
                  ]
                : []),

              ...(hasDivider ? [createHrBlock()] : []),

              ...(description
                ? [
                    createPBlock({
                      text: description,
                      styles: {
                        color: getColorOptions(
                          "var(--theme-website-color-text-secondary)",
                        ),
                        fontWeight: getFontWeightOptions("500"),
                        fontSize: getFontSizeOptions("1rem"),
                      },
                    }),
                  ]
                : []),
              ...(button && button.text && button.href
                ? [
                    createButtonBlock({
                      text: button.text,
                      href: button.href,
                      styles: {
                        margin: getMarginOptions({
                          defaultValue: {
                            marginTop: "20",
                            marginBottom: "0",
                            marginLeft: "0",
                            marginRight: "0",
                          },
                        }),
                      },
                    }),
                  ]
                : []),
            ].filter(Boolean),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...(CardDefaultData.props?.styles?.value as Record<string, StyleValue>),
        ...styles,
      },
    },
  },
});
